module.exports = __webpack_public_path__ + "media/src/images/icons/icons8-inspection-393e8727bfa42185d6957529116d2048.png";